import { useEffect, useState } from "react";
import { TextField, MenuItem, Select,FormControl, Autocomplete, Checkbox,} from "@mui/material";
import { IoIosArrowBack } from "react-icons/io";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { newFilterEntities,} from "../../../apis/apiService";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ExpandMore } from "@mui/icons-material";
import { useFetchMilestoneTasksQuery, useFetchTaskNameByIdQuery} from "../../../slice/logdetailSlice";

export const MilestoneTaskBoardFilter = ({
  onApply,
  onClear,
  onCancel,
  filterid,
  isMilestoneTask,
  project_id,
  milestone_id,
  filter_path,
  isSubtask,
  task_list_id,
}) => {

  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data: projectNames, refetch: refetchProjectTasks } = useFetchTaskNameByIdQuery(project_id, {
    skip: !project_id,
  });
  const usersInProjects = useSelector((state) => state.selectOptions?.userNamesByProjects);
  const { data: taskNames, refetch: refetchMilestoneTasks } = useFetchMilestoneTasksQuery(milestone_id, {
    skip: !milestone_id,
  });

  useEffect(() => {
    if (project_id) refetchProjectTasks();
    if (milestone_id) refetchMilestoneTasks();
  }, [project_id, milestone_id, refetchProjectTasks, refetchMilestoneTasks]);

  const activestatus = useSelector((state) => state.selectOptions.StatusOptions);
  const activityStatus = activestatus.find((status) => status.status_type === "TASK");
  const statusList = activityStatus?.status_details.map((status) => ({
    id: status.status_id,
    status_name: status.status_name,
    status_colour: status.status_colour,
  }));

  // Separate storage key for Milestone Board
  const sessionFilteredData = sessionStorage.getItem("milestone_board_filter_data");
  const filterDatas = JSON.parse(sessionFilteredData);

  const { handleSubmit, control, reset, } = useForm({
    defaultValues: {
      taskTitle: filterDatas?.title || [],
      owner: filterDatas?.project_manager_id || "",
      createdBy: filterDatas?.added_by || "",
      createdDate: filterDatas?.added_at ? dayjs(filterDatas.added_at) : null,
      lastModifiedBy: filterDatas?.updated_by || "",
      startDate: filterDatas?.start_date
        ? dayjs(filterDatas?.start_date)
        : null,
      endDate: filterDatas?.end_date ? dayjs(filterDatas?.end_date) : null,
      status: filterDatas?.current_status_id || "",
      billingType: filterDatas?.billing_type || "",
    },
  });

  const onSubmit = async (data) => {
    const hasActiveFilter = 
      (data.taskTitle && data.taskTitle.length > 0) ||
      data.owner ||
      data.startDate ||
      data.endDate ||
      data.billingType ||
      data.createdBy ||
      data.status ||
      data.createdDate ||
      data.lastModifiedBy;

    if (!hasActiveFilter) {
      toast.info("No filter values selected. Select one or more filters to apply");
      return;
    }

    const requestedData = {
      view_type_id: filterid,
      title: data.taskTitle,
      owner: parseInt(data.owner, 10) || null,
      start_date: data.startDate
        ? format(new Date(data.startDate), "yyyy-MM-dd")
        : null,
      end_date: data.endDate
        ? format(new Date(data.endDate), "yyyy-MM-dd")
        : null,
      // billing_type: data.billingType || null,
      billing_type: data.billingType === "NON_BILLABLE" ? "NON-BILLABLE" : data.billingType || null,
      added_by: parseInt(data.createdBy, 10) || null,
      current_status_id: data.status || null,
      added_at: data.createdDate
        ? format(new Date(data.createdDate), "yyyy-MM-dd")
        : null,
      updated_by: data.lastModifiedBy
        ? parseInt(data.lastModifiedBy, 10)
        : null,
    };
    setIsSubmitting(true);
    try {
      const response = await newFilterEntities(
        filter_path,
        isMilestoneTask ? milestone_id : isSubtask ? task_list_id : project_id,
        requestedData
      );
      if (response && response.data && response.data.length > 0) {
        onApply(response.data);
        sessionStorage.setItem("isMilestoneBoardFilterApplied", true);
        sessionStorage.setItem(
          "milestone_board_filter_data",
          JSON.stringify(requestedData)
        );
        toast.success(response.message || "Filter applied successfully");
      } 
      else {
        onApply([]);
        sessionStorage.setItem("isMilestoneBoardFilterApplied", true);
        sessionStorage.setItem(
          "milestone_board_filter_data",
          JSON.stringify(requestedData)
        );
        toast.info("No data found");
      }
    } 
    catch (err) {
      toast.error(err.message || "Failed to fetch filtered tasks.");
    } 
    finally {
      setIsSubmitting(false);
    }
  };

  const handleClear = () => {
    reset({
      taskTitle: [],
      owner: "",
      createdBy: "",
      createdDate: null,
      lastModifiedBy: "",
      startDate: null,
      endDate: null,
      status: "",
      billingType: "",
    });
    onClear();
  };

  return (
    <div className="" style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Milestone Board Filter
          </div>
        </button>
        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red"
          >
            Clear Filter
          </button>
        </div>
      </div>

      <div className="bg-white" style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div className="px-4 py-3" style={{ flex: 1, overflowY: "auto", paddingBottom: "100px" }}>
              <div className="row mb-3">
                <div className="col-12">
                  <label htmlFor="taskTitle" className="form-label">Search By Task</label>
                  <Controller
                    name="taskTitle"
                    control={control}
                    render={({ field: { onChange, value } }) => {
                      const options = isMilestoneTask
                        ? Array.isArray(taskNames)
                          ? taskNames
                          : []
                        : Array.isArray(projectNames)
                        ? projectNames
                        : [];

                      const selectedOptions = (value || [])
                        .map((title) =>
                          options.find((item) => item.title === title)
                        )
                        .filter(Boolean);

                      return (
                        <Autocomplete
                          multiple
                          id="taskTitle"
                          options={options}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.title}
                          value={selectedOptions}
                          onChange={(event, newValue) => {
                            const selectedTitles = newValue.map(
                              (item) => item.title
                            );
                            onChange(selectedTitles);
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.title}</strong>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search by task"
                            />
                          )}
                          ListboxProps={{
                            style: {
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: "8px",
                              paddingLeft: "0",
                            },
                          }}
                        />
                      );
                    }}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="owner" className="form-label">Owner</label>
                  <Controller
                    control={control}
                    name="owner"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              usersInProjects.find(
                                (owner) => owner.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select owner</span>
                            )
                          }
                          IconComponent={ExpandMore}
                        >
                          {usersInProjects?.map((ownerName) => (
                            <MenuItem key={ownerName.user_id} value={ownerName.user_id}>
                              {ownerName.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
                
                <div className="col-md-6">
                  <label htmlFor="createdDate" className="form-label">Created Date</label>
                  <Controller
                    name="createdDate"
                    control={control}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        onChange={(date) => field.onChange(date)}
                        sx={{ width: '100%' }}
                      />
                    )}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="createdBy" className="form-label">Created By</label>
                  <Controller
                    control={control}
                    name="createdBy"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              usersInProjects.find(
                                (user) => user.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                          IconComponent={ExpandMore}
                        >
                          {usersInProjects?.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="lastModifiedBy" className="form-label">Last Modified By</label>
                  <Controller
                    control={control}
                    name="lastModifiedBy"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              usersInProjects.find(
                                (statusName) => statusName.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                          IconComponent={ExpandMore}
                        >
                          {usersInProjects?.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="startDate" className="form-label">Start Date</label>
                  <Controller
                    name="startDate"
                    control={control}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        onChange={(date) => field.onChange(date)}
                        sx={{ width: '100%' }}
                      />
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="endDate" className="form-label">End Date</label>
                  <Controller
                    name="endDate"
                    control={control}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        onChange={(date) => field.onChange(date)}
                        sx={{ width: '100%' }}
                      />
                    )}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="status" className="form-label">Status</label>
                  <FormControl fullWidth>
                    <Controller
                      name="status"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          value={field.value || ""}
                          displayEmpty
                          renderValue={(selected) => {
                            const selectedValue = statusList?.find(
                              (statusName) => statusName.id === selected
                            );
                            return selectedValue ? (
                              <span style={{ color: selectedValue.status_colour }}>
                                {selectedValue.status_name}
                              </span>
                            ) : (
                              <span className="lightText">Select status</span>
                            );
                          }}
                          IconComponent={ExpandMoreIcon}
                        >
                          {statusList?.map((status, index) => (
                            <MenuItem
                              key={index}
                              style={{ color: status.status_colour || "black" }}
                              value={status.id}
                            >
                              {status.status_name}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </div>
                
                <div className="col-md-6">
                  <label htmlFor="billingType" className="form-label">Billing Type</label>
                  <Controller
                    control={control}
                    name="billingType"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          IconComponent={ExpandMore}
                          displayEmpty
                          renderValue={(selected) => selected || <span className="lightText">Select type</span>}
                          {...field}
                        >
                          <MenuItem value="BILLABLE">Billable</MenuItem>
                          <MenuItem value="NON_BILLABLE">Non-Billable</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>
            </div>

            <div className="bg-white px-4 py-3 position-sticky bottom-0 w-100" style={{ zIndex: 10, marginTop: "auto" }}>
              <div className="d-flex justify-content-left">
                <button type="submit" className="me-3 add_btn" disabled={isSubmitting}>
                  {isSubmitting ? "Applying..." : "Apply"}
                </button>
                <button type="button" className="cancel_btn" onClick={onCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};
